"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryResponseResultsInner = instanceOfApiPostQueryResponseResultsInner;
exports.ApiPostQueryResponseResultsInnerFromJSON = ApiPostQueryResponseResultsInnerFromJSON;
exports.ApiPostQueryResponseResultsInnerFromJSONTyped = ApiPostQueryResponseResultsInnerFromJSONTyped;
exports.ApiPostQueryResponseResultsInnerToJSON = ApiPostQueryResponseResultsInnerToJSON;
exports.ApiPostQueryResponseResultsInnerToJSONTyped = ApiPostQueryResponseResultsInnerToJSONTyped;
/**
 * Check if a given object implements the ApiPostQueryResponseResultsInner interface.
 */
function instanceOfApiPostQueryResponseResultsInner(value) {
    return true;
}
function ApiPostQueryResponseResultsInnerFromJSON(json) {
    return ApiPostQueryResponseResultsInnerFromJSONTyped(json, false);
}
function ApiPostQueryResponseResultsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : json['data'],
    };
}
function ApiPostQueryResponseResultsInnerToJSON(json) {
    return ApiPostQueryResponseResultsInnerToJSONTyped(json, false);
}
function ApiPostQueryResponseResultsInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'],
    };
}
